import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/Chat";
import type { FidelizacionLote } from "../fidelizacion-campana.interface";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  lote: FidelizacionLote | null;
  nombreHsm: string;
  dryRun?: boolean;
};

///* Confirmación del envío. Los campos (AppId y nombre de plantilla) se eligen en el
///* paso 3 de la página, no aquí: este diálogo solo resume y pide confirmación.
export const EnviarHsmModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  lote,
  nombreHsm,
  dryRun,
}: Props) => {
  const contactables = lote?.contactables ?? 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Confirmar envío</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5} sx={{ mt: 0.5 }}>
          {dryRun && (
            <Alert severity="warning" sx={{ py: 0 }}>
              Modo simulación: no se enviarán WhatsApp reales.
            </Alert>
          )}

          <DialogContentText sx={{ p: 0 }}>
            SocialHub enviará la plantilla <strong>{nombreHsm || "—"}</strong> a{" "}
            <strong>{contactables}</strong> contactos, uno a uno. Puede tardar varios minutos.
          </DialogContentText>

          <Typography variant="caption" color="text.secondary">
            Los parámetros salen de las columnas parametro_1..N del archivo cargado.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="success"
          startIcon={<WhatsAppIcon />}
          onClick={onConfirm}
          disabled={loading || contactables === 0}
        >
          {loading ? "Enviando..." : `Enviar a ${contactables}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
